/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const byAccount = /* GraphQL */ `query ByAccount($input: ByAccountInput!) {
  byAccount(input: $input) {
    items {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ByAccountQueryVariables, APITypes.ByAccountQuery>;
export const getAccount = /* GraphQL */ `query GetAccount($id: ID!) {
  getAccount(id: $id) {
    id
    gid
    name
    projects {
      nextToken
      __typename
    }
    fileuploads {
      originalName
      createdAt
      fileName
      fileStatus
      fileError
      numRecords
      numErrors
      totalRecords
      writtenRecords
      __typename
    }
    integrations {
      hubspot
      klaviyo
      __typename
    }
    defaultSchemaMappings {
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    aliasId
    fonts {
      fontFamily
      __typename
    }
    mediaGallery {
      url
      projectId
      type
      __typename
    }
    minisiteDomain
    mfaEnabled
    ownerId
    users {
      nextToken
      __typename
    }
    accountUsageType
    companySize
    tierId
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    featureOverrides {
      nextToken
      __typename
    }
    createNewVideosWithBlingLogo
    accountType {
      levelName
      __typename
    }
    currentBillingPeriod {
      startDate
      endDate
      __typename
    }
    ppvCurrentBillingPeriod {
      startDate
      endDate
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    branding
    defaultCrm
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountQueryVariables,
  APITypes.GetAccountQuery
>;
export const listAccounts = /* GraphQL */ `query ListAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsQueryVariables,
  APITypes.ListAccountsQuery
>;
export const getAccountUser = /* GraphQL */ `query GetAccountUser($id: ID!) {
  getAccountUser(id: $id) {
    id
    email
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    accountId
    user {
      id
      email
      name
      lastName
      picture
      createdAt
      updatedAt
      __typename
    }
    userId
    createdAt
    updatedAt
    workType
    roleInCompany
    permissions
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountUserQueryVariables,
  APITypes.GetAccountUserQuery
>;
export const listUsersThatWorkOnAccount = /* GraphQL */ `query ListUsersThatWorkOnAccount(
  $accountId: ID!
  $userId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAccountUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsersThatWorkOnAccount(
    accountId: $accountId
    userId: $userId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      accountId
      userId
      createdAt
      updatedAt
      workType
      roleInCompany
      permissions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsersThatWorkOnAccountQueryVariables,
  APITypes.ListUsersThatWorkOnAccountQuery
>;
export const listAccountsForUser = /* GraphQL */ `query ListAccountsForUser(
  $userId: ID!
  $accountId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAccountUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccountsForUser(
    userId: $userId
    accountId: $accountId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      accountId
      userId
      createdAt
      updatedAt
      workType
      roleInCompany
      permissions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsForUserQueryVariables,
  APITypes.ListAccountsForUserQuery
>;
export const getInvite = /* GraphQL */ `query GetInvite($id: ID!) {
  getInvite(id: $id) {
    id
    senderId
    email
    accountId
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    confirmCode
    confirmed
    createdAt
    updatedAt
    permissions
    __typename
  }
}
` as GeneratedQuery<APITypes.GetInviteQueryVariables, APITypes.GetInviteQuery>;
export const listInvites = /* GraphQL */ `query ListInvites(
  $id: ID
  $filter: ModelInviteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listInvites(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      senderId
      email
      accountId
      confirmCode
      confirmed
      createdAt
      updatedAt
      permissions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvitesQueryVariables,
  APITypes.ListInvitesQuery
>;
export const listInvitesBySender = /* GraphQL */ `query ListInvitesBySender(
  $senderId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInviteFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvitesBySender(
    senderId: $senderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      senderId
      email
      accountId
      confirmCode
      confirmed
      createdAt
      updatedAt
      permissions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvitesBySenderQueryVariables,
  APITypes.ListInvitesBySenderQuery
>;
export const listInvitesByAccount = /* GraphQL */ `query ListInvitesByAccount(
  $accountId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelInviteFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvitesByAccount(
    accountId: $accountId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      senderId
      email
      accountId
      confirmCode
      confirmed
      createdAt
      updatedAt
      permissions
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvitesByAccountQueryVariables,
  APITypes.ListInvitesByAccountQuery
>;
export const getTier = /* GraphQL */ `query GetTier($id: ID!) {
  getTier(id: $id) {
    id
    name
    monthlyPrice
    annualPrice
    description
    enabled
    features {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTierQueryVariables, APITypes.GetTierQuery>;
export const listTiers = /* GraphQL */ `query ListTiers(
  $filter: ModelTierFilterInput
  $limit: Int
  $nextToken: String
) {
  listTiers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTiersQueryVariables, APITypes.ListTiersQuery>;
export const getFeature = /* GraphQL */ `query GetFeature($id: ID!) {
  getFeature(id: $id) {
    id
    name
    description
    enabled
    tierFeatures {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFeatureQueryVariables,
  APITypes.GetFeatureQuery
>;
export const listFeatures = /* GraphQL */ `query ListFeatures(
  $filter: ModelFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  listFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFeaturesQueryVariables,
  APITypes.ListFeaturesQuery
>;
export const getTierFeature = /* GraphQL */ `query GetTierFeature($id: ID!) {
  getTierFeature(id: $id) {
    id
    tier {
      id
      name
      monthlyPrice
      annualPrice
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    tierId
    feature {
      id
      name
      description
      enabled
      createdAt
      updatedAt
      __typename
    }
    featureId
    description
    limitValue
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTierFeatureQueryVariables,
  APITypes.GetTierFeatureQuery
>;
export const listTierFeatures = /* GraphQL */ `query ListTierFeatures(
  $filter: ModelTierFeatureFilterInput
  $limit: Int
  $nextToken: String
) {
  listTierFeatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      tierId
      featureId
      description
      limitValue
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTierFeaturesQueryVariables,
  APITypes.ListTierFeaturesQuery
>;
export const getAccountFeatureOverride = /* GraphQL */ `query GetAccountFeatureOverride($id: ID!) {
  getAccountFeatureOverride(id: $id) {
    id
    accountId
    featureId
    reason
    limitValue
    enabled
    expiresAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountFeatureOverrideQueryVariables,
  APITypes.GetAccountFeatureOverrideQuery
>;
export const listAccountFeatureOverrides = /* GraphQL */ `query ListAccountFeatureOverrides(
  $filter: ModelAccountFeatureOverrideFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccountFeatureOverrides(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountId
      featureId
      reason
      limitValue
      enabled
      expiresAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountFeatureOverridesQueryVariables,
  APITypes.ListAccountFeatureOverridesQuery
>;
export const getFormData = /* GraphQL */ `query GetFormData($id: ID!) {
  getFormData(id: $id) {
    id
    accountOwner
    projectFormDataId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    data
    sessionId
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFormDataQueryVariables,
  APITypes.GetFormDataQuery
>;
export const listFormData = /* GraphQL */ `query ListFormData(
  $filter: ModelFormDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listFormData(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountOwner
      projectFormDataId
      data
      sessionId
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFormDataQueryVariables,
  APITypes.ListFormDataQuery
>;
export const formDataByDate = /* GraphQL */ `query FormDataByDate(
  $projectFormDataId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFormDataFilterInput
  $limit: Int
  $nextToken: String
) {
  formDataByDate(
    projectFormDataId: $projectFormDataId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountOwner
      projectFormDataId
      data
      sessionId
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FormDataByDateQueryVariables,
  APITypes.FormDataByDateQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    type
    subType
    status
    title
    message
    read
    owner
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    createdAt
    extra
    updatedAt
    projectNotificationsId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      subType
      status
      title
      message
      read
      owner
      projectId
      createdAt
      extra
      updatedAt
      projectNotificationsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const listNotificationByType = /* GraphQL */ `query ListNotificationByType(
  $type: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotificationByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      subType
      status
      title
      message
      read
      owner
      projectId
      createdAt
      extra
      updatedAt
      projectNotificationsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationByTypeQueryVariables,
  APITypes.ListNotificationByTypeQuery
>;
export const listNotificationByOwner = /* GraphQL */ `query ListNotificationByOwner(
  $owner: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotificationByOwner(
    owner: $owner
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      subType
      status
      title
      message
      read
      owner
      projectId
      createdAt
      extra
      updatedAt
      projectNotificationsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationByOwnerQueryVariables,
  APITypes.ListNotificationByOwnerQuery
>;
export const getProject = /* GraphQL */ `query GetProject($id: ID!) {
  getProject(id: $id) {
    id
    projectAccountId
    title
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    allowCreateDataPoint
    allowDataConnect
    allowCrmConnect
    allowSdkConnect
    allowSendFormData
    analyticsReportUrl
    createdAt
    dataFiles {
      fileName
      tag
      createdAt
      __typename
    }
    description
    fileName
    jsonChanges
    jsonVidUrl
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    customLoaderAssets {
      spinnerUrl
      diamondUrl
      loaderUrl
      __typename
    }
    projectVersions {
      nextToken
      __typename
    }
    formData {
      nextToken
      __typename
    }
    settings
    stateJsonSchemaStr
    settingsJsonSchemaStr
    thumbS3Url
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    analyticsEnabled
    owner
    renders {
      nextToken
      __typename
    }
    notifications {
      nextToken
      __typename
    }
    aliasId
    minisiteConfigs {
      scenes
      title
      description
      thumbUrl
      faviconUrl
      preCreate
      __typename
    }
    playerVersionToUse
    customHtml
    dynamicThumbnails {
      name
      id
      createdAt
      updatedAt
      __typename
    }
    publishedAt
    allowedOrigins
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    textToVideoScript
    instantiatedFromUseCase
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    isDeleted
    availableSceneLibraries {
      nextToken
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    crmTokens {
      selectedCrm
      hubspot
      klaviyo
      activeCampaign
      braze
      salesforceMarketingCloud
      adobeCampaign
      adobeJourneyOptimizer
      mailchimp
      marketo
      others
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectQueryVariables,
  APITypes.GetProjectQuery
>;
export const listProjects = /* GraphQL */ `query ListProjects(
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectsQueryVariables,
  APITypes.ListProjectsQuery
>;
export const listProjectsByAccount = /* GraphQL */ `query ListProjectsByAccount(
  $projectAccountId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectsByAccount(
    projectAccountId: $projectAccountId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectsByAccountQueryVariables,
  APITypes.ListProjectsByAccountQuery
>;
export const getProjectByAliasId = /* GraphQL */ `query GetProjectByAliasId(
  $aliasId: String!
  $projectAccountId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  getProjectByAliasId(
    aliasId: $aliasId
    projectAccountId: $projectAccountId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectByAliasIdQueryVariables,
  APITypes.GetProjectByAliasIdQuery
>;
export const getProjectChangeActivity = /* GraphQL */ `query GetProjectChangeActivity($id: ID!) {
  getProjectChangeActivity(id: $id) {
    projectId
    before {
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      type
      owner
      __typename
    }
    after {
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      type
      owner
      __typename
    }
    owner
    email
    origin
    accountOwner
    createdAt
    id
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectChangeActivityQueryVariables,
  APITypes.GetProjectChangeActivityQuery
>;
export const listProjectChangeActivities = /* GraphQL */ `query ListProjectChangeActivities(
  $filter: ModelProjectChangeActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectChangeActivities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      projectId
      owner
      email
      origin
      accountOwner
      createdAt
      id
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectChangeActivitiesQueryVariables,
  APITypes.ListProjectChangeActivitiesQuery
>;
export const getProjectVersionChangeActivity = /* GraphQL */ `query GetProjectVersionChangeActivity($id: ID!) {
  getProjectVersionChangeActivity(id: $id) {
    projectId
    before {
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      type
      owner
      __typename
    }
    after {
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      type
      owner
      __typename
    }
    owner
    origin
    accountOwner
    createdAt
    id
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectVersionChangeActivityQueryVariables,
  APITypes.GetProjectVersionChangeActivityQuery
>;
export const listProjectVersionChangeActivities = /* GraphQL */ `query ListProjectVersionChangeActivities(
  $filter: ModelProjectVersionChangeActivityFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectVersionChangeActivities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      projectId
      owner
      origin
      accountOwner
      createdAt
      id
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectVersionChangeActivitiesQueryVariables,
  APITypes.ListProjectVersionChangeActivitiesQuery
>;
export const getProjectVersion = /* GraphQL */ `query GetProjectVersion($id: ID!) {
  getProjectVersion(id: $id) {
    id
    accountOwner
    owner
    stateJsonSchemaStr
    settingsJsonSchemaStr
    settings
    videoParts {
      name
      jsonUrl
      mods
      updatedAt
      hasVideo
      origin
      playerVersionToUse
      description
      __typename
    }
    updatedAt
    playerVersionToUse
    experiments {
      id
      type
      __typename
    }
    experimentOptimizationTechnique
    textToVideoScript
    flowDiagram {
      __typename
    }
    nodeLayout {
      __typename
    }
    overlay {
      __typename
    }
    fontOverrides {
      family
      url
      weight
      style
      __typename
    }
    playerSettings {
      autoplay
      autoplay_delay
      posterFrame
      showTimeline
      storiesMode
      color_loader
      color_ctrlBtns
      color_rail
      color_progress
      color_thumb
      color_bg
      muted
      autoReplay
      showBlingsLogo
      blingsLogoColor
      loadingText
      loadingImage
      __typename
    }
    fontMap {
      slot
      __typename
    }
    customHooks {
      name
      description
      hookType
      code
      createdAt
      updatedAt
      __typename
    }
    createdAt
    projectProjectVersionsId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectVersionQueryVariables,
  APITypes.GetProjectVersionQuery
>;
export const listProjectVersions = /* GraphQL */ `query ListProjectVersions(
  $filter: ModelProjectVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectVersions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountOwner
      owner
      stateJsonSchemaStr
      settingsJsonSchemaStr
      settings
      updatedAt
      playerVersionToUse
      experimentOptimizationTechnique
      textToVideoScript
      createdAt
      projectProjectVersionsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectVersionsQueryVariables,
  APITypes.ListProjectVersionsQuery
>;
export const listProjectVersionsByAccount = /* GraphQL */ `query ListProjectVersionsByAccount(
  $accountOwner: String!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProjectVersionFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectVersionsByAccount(
    accountOwner: $accountOwner
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountOwner
      owner
      stateJsonSchemaStr
      settingsJsonSchemaStr
      settings
      updatedAt
      playerVersionToUse
      experimentOptimizationTechnique
      textToVideoScript
      createdAt
      projectProjectVersionsId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectVersionsByAccountQueryVariables,
  APITypes.ListProjectVersionsByAccountQuery
>;
export const getSceneLibrary = /* GraphQL */ `query GetSceneLibrary($id: ID!) {
  getSceneLibrary(id: $id) {
    id
    title
    vibe
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    description
    thumbnail
    accounts {
      nextToken
      __typename
    }
    useCases {
      nextToken
      __typename
    }
    projects {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSceneLibraryQueryVariables,
  APITypes.GetSceneLibraryQuery
>;
export const listSceneLibraries = /* GraphQL */ `query ListSceneLibraries(
  $filter: ModelSceneLibraryFilterInput
  $limit: Int
  $nextToken: String
) {
  listSceneLibraries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSceneLibrariesQueryVariables,
  APITypes.ListSceneLibrariesQuery
>;
export const getServerRender = /* GraphQL */ `query GetServerRender($id: ID!) {
  getServerRender(id: $id) {
    id
    projectId
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    scenes
    data
    env
    outputFileName
    quality
    frameToStart
    frameToEnd
    format
    status {
      ready
      status
      downloadLink
      code
      __typename
    }
    cognitoUserIdentifier
    cognitoGroupOwner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetServerRenderQueryVariables,
  APITypes.GetServerRenderQuery
>;
export const listServerRenders = /* GraphQL */ `query ListServerRenders(
  $filter: ModelServerRenderFilterInput
  $limit: Int
  $nextToken: String
) {
  listServerRenders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      scenes
      data
      env
      outputFileName
      quality
      frameToStart
      frameToEnd
      format
      cognitoUserIdentifier
      cognitoGroupOwner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListServerRendersQueryVariables,
  APITypes.ListServerRendersQuery
>;
export const getUseCase = /* GraphQL */ `query GetUseCase($id: ID!) {
  getUseCase(id: $id) {
    id
    name
    projectId
    images
    shortDescription
    longDescription
    thumbnail
    demoLink
    videoPreview
    lineupId
    lineupsIds
    scenes
    liveControl
    liveControlSchema
    dynamicDataSchema
    categoryId
    category {
      id
      name
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    availableSceneLibraries {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUseCaseQueryVariables,
  APITypes.GetUseCaseQuery
>;
export const listUseCases = /* GraphQL */ `query ListUseCases(
  $filter: ModelUseCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listUseCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUseCasesQueryVariables,
  APITypes.ListUseCasesQuery
>;
export const getUseCaseTag = /* GraphQL */ `query GetUseCaseTag($tag: String!) {
  getUseCaseTag(tag: $tag) {
    tag
    useCaseIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUseCaseTagQueryVariables,
  APITypes.GetUseCaseTagQuery
>;
export const listUseCaseTags = /* GraphQL */ `query ListUseCaseTags(
  $tag: String
  $filter: ModelUseCaseTagFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUseCaseTags(
    tag: $tag
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      tag
      useCaseIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUseCaseTagsQueryVariables,
  APITypes.ListUseCaseTagsQuery
>;
export const getUseCaseCategory = /* GraphQL */ `query GetUseCaseCategory($id: ID!) {
  getUseCaseCategory(id: $id) {
    id
    name
    description
    thumbnail
    useCases {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUseCaseCategoryQueryVariables,
  APITypes.GetUseCaseCategoryQuery
>;
export const listUseCaseCategories = /* GraphQL */ `query ListUseCaseCategories(
  $id: ID
  $filter: ModelUseCaseCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUseCaseCategories(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUseCaseCategoriesQueryVariables,
  APITypes.ListUseCaseCategoriesQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    email
    name
    lastName
    picture
    accounts {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      name
      lastName
      picture
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getAccountSceneLibraries = /* GraphQL */ `query GetAccountSceneLibraries($id: ID!) {
  getAccountSceneLibraries(id: $id) {
    id
    accountID
    sceneLibraryID
    account {
      id
      gid
      name
      aliasId
      minisiteDomain
      mfaEnabled
      ownerId
      accountUsageType
      companySize
      tierId
      stripeCustomerId
      createNewVideosWithBlingLogo
      branding
      defaultCrm
      createdAt
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountSceneLibrariesQueryVariables,
  APITypes.GetAccountSceneLibrariesQuery
>;
export const listAccountSceneLibraries = /* GraphQL */ `query ListAccountSceneLibraries(
  $filter: ModelAccountSceneLibrariesFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccountSceneLibraries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accountID
      sceneLibraryID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountSceneLibrariesQueryVariables,
  APITypes.ListAccountSceneLibrariesQuery
>;
export const getProjectSceneLibraries = /* GraphQL */ `query GetProjectSceneLibraries($id: ID!) {
  getProjectSceneLibraries(id: $id) {
    id
    projectID
    sceneLibraryID
    project {
      id
      projectAccountId
      title
      allowCreateDataPoint
      allowDataConnect
      allowCrmConnect
      allowSdkConnect
      allowSendFormData
      analyticsReportUrl
      createdAt
      description
      fileName
      jsonChanges
      jsonVidUrl
      settings
      stateJsonSchemaStr
      settingsJsonSchemaStr
      thumbS3Url
      experimentOptimizationTechnique
      analyticsEnabled
      owner
      aliasId
      playerVersionToUse
      customHtml
      publishedAt
      allowedOrigins
      textToVideoScript
      instantiatedFromUseCase
      isDeleted
      updatedAt
      __typename
    }
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectSceneLibrariesQueryVariables,
  APITypes.GetProjectSceneLibrariesQuery
>;
export const listProjectSceneLibraries = /* GraphQL */ `query ListProjectSceneLibraries(
  $filter: ModelProjectSceneLibrariesFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectSceneLibraries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectID
      sceneLibraryID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectSceneLibrariesQueryVariables,
  APITypes.ListProjectSceneLibrariesQuery
>;
export const getUseCaseSceneLibraries = /* GraphQL */ `query GetUseCaseSceneLibraries($id: ID!) {
  getUseCaseSceneLibraries(id: $id) {
    id
    sceneLibraryID
    useCaseID
    sceneLibrary {
      id
      title
      vibe
      projectId
      description
      thumbnail
      createdAt
      updatedAt
      __typename
    }
    useCase {
      id
      name
      projectId
      images
      shortDescription
      longDescription
      thumbnail
      demoLink
      videoPreview
      lineupId
      lineupsIds
      scenes
      liveControl
      liveControlSchema
      dynamicDataSchema
      categoryId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUseCaseSceneLibrariesQueryVariables,
  APITypes.GetUseCaseSceneLibrariesQuery
>;
export const listUseCaseSceneLibraries = /* GraphQL */ `query ListUseCaseSceneLibraries(
  $filter: ModelUseCaseSceneLibrariesFilterInput
  $limit: Int
  $nextToken: String
) {
  listUseCaseSceneLibraries(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      sceneLibraryID
      useCaseID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUseCaseSceneLibrariesQueryVariables,
  APITypes.ListUseCaseSceneLibrariesQuery
>;
